module.exports = __webpack_public_path__ + "static/media/apparaturen_schema.38610358.jpg";